import {
  coerceCssPixelValue,
  NumberInput,
  coerceNumberProperty,
} from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'lui-smart-grid',
  template: `<ng-content></ng-content>`,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartGridComponent {
  @HostBinding('class') hostClass = 'lui-smart-grid';

  @Input() get minWidth() {
    return this.minWidthCss;
  }
  set minWidth(value: unknown) {
    this.minWidthCss = coerceCssPixelValue(value);
  }
  @HostBinding('style.--lui-smart-grid-min-width') minWidthCss = '20rem';

  @Input() get minPerRowAtXs() {
    return this.minWidthCss;
  }
  set minPerRowAtXs(value: NumberInput) {
    const n = coerceNumberProperty(value);
    this.gridTempAtXs = n === 1 ? '1fr' : `repeat(${n}, 1fr)`;
  }

  @HostBinding('style.--lui-smar-grid-sm-template') gridTempAtXs = '1fr';
}
